import Carousel1 from "../../asserts/meet-team5.webp"
import Carousel2 from "../../asserts/meet-team2.webp"
import Carousel3 from "../../asserts/meet-team3.webp"
import Carousel4 from "../../asserts/meet-team4.webp"

export const TeamsItems = [
    {
        id:'HUSNAINIMRAN',
        image: Carousel1,
        Name: 'HUSSNAIN IMRAN', 
        Major: 'WEB DEVELOPER',
        Experience: '6 Year Experience',
        Profile:'info@egeneus.com',
    },
    {
        id:'AYESHAMIRZA',
        image: Carousel2,
        Name: 'AYESHA MIRZA', 
        Major: 'content writer',
        Experience: '5 Year Experience',
        Profile:'info@egeneus.com',
    },
    {
        id:'NAZIMALI',
        image: Carousel3,
        Name: 'NAZIM ALI', 
        Major: 'SMM EXPERT',
        Experience: '6 Year Experience',
        Profile:'info@egeneus.com',
    },
    {
        id:'UMARFAROOQ',
        image: Carousel4,
        Name: 'UMAR FAROOQ', 
        Major: 'SEO EXPERT',
        Experience: '8 Year Experience',
        Profile:'info@egeneus.com',
    },

  ];
  
  
  
  
  
  
  